import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { primeConfig } from '@cfg/design/prime.config';
import { initializePrimeTranslation } from '@cfg/i18n/initializer';
import { translationConfig } from '@cfg/i18n/translation.config';
import { APP_ROUTES } from '@view/routes';
import { AppComponent } from '@view/app.component';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    provideHttpClient(),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => initializePrimeTranslation()),
    ...primeConfig,
    ...translationConfig
  ]
}).catch((err) => console.error(err));
